import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MutasiVoucherPdf = (
  data = [],
  namaBulan,
  tahun
) => {
  namaBulan = namaBulan || "Tidak Diketahui";
  tahun = tahun || new Date().getFullYear();

  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

const drawHeader = (judul, subJudul, logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(judul, pageWidth / 2, reportY, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(subJudul, pageWidth / 2, reportY + 6, {
    align: "center",
  });

  return reportY + 10;
};

 const judul = "Mutasi Simpanan Voucher";
 const subJudul = `${namaBulan} ${tahun}`;

  const totalSaldoAwal = data.reduce(
    (sum, item) => sum + Number(item.saldoawal || 0),
    0
  );

  const totalSetor = data.reduce(
    (sum, item) => sum + Number(item.setor || 0),
    0
  );

  const totalTarik = data.reduce(
    (sum, item) => sum + Number(item.tarik || 0),
    0
  );

  const totalSaldoAkhir = data.reduce(
    (sum, item) => sum + Number(item.saldoakh || 0),
    0
  );

  const body = data.map((item) => [
    item.noanggota || "",
    item.nama || "",
    Number(item.saldoawal || 0).toLocaleString("id-ID"),
    Number(item.setor || 0).toLocaleString("id-ID"),
    Number(item.tarik || 0).toLocaleString("id-ID"),
    Number(item.saldoakh || 0).toLocaleString("id-ID"),
  ]);

  // Baris TOTAL
  body.push([
    "",
    "TOTAL",
    totalSaldoAwal.toLocaleString("id-ID"),
    totalSetor.toLocaleString("id-ID"),
    totalTarik.toLocaleString("id-ID"),
    totalSaldoAkhir.toLocaleString("id-ID"),
  ]);

  const renderTable = (startY) => {
  autoTable(doc, {
    startY,

    head: [[
      "NO ANGGOTA",
      "NAMA",
      "SALDO AWAL",
      "SETOR",
      "TARIK",
      "SALDO AKHIR"
    ]],

    body,

    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
    },

    headStyles: {
      fillColor: [0, 191, 165],
      textColor: 255,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      fontSize: 8,
    },

    margin: {
      left: 8,
      right: 8,
      top: 20,
      bottom: 10,
    },

    tableWidth: "stretch",

    columnStyles: {
      0: {
        cellWidth: 25,
        halign: "center",
      },
      1: {
        cellWidth: 55,
        halign: "left",
      },
      2: {
        cellWidth: 28,
        halign: "right",
      },
      3: {
        cellWidth: 25,
        halign: "right",
      },
      4: {
        cellWidth: 25,
        halign: "right",
      },
      5: {
        cellWidth: 28,
        halign: "right",
      },
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },

    showHead: "everyPage",
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(
      "Mutasi Simpanan Voucher",
      `${namaBulan} ${tahun}`,
      logoDataUrl
    );
    renderTable(startY);
  })
  .catch(() => {
    const startY = drawHeader(
      "Mutasi Simpanan Voucher",
      `${namaBulan} ${tahun}`
    );
    renderTable(startY);
  });
};


export default MutasiVoucherPdf;